import React, { useState, useEffect, useRef } from "react";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { UrlPath } from "../../../config/routeConfig";
import { TopBar } from "../../shared/topBar/TopBar";
import { useNavigate, useParams, useLocation } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { SBADropDown, SBAComboBox } from "../../UiComponents/SBADropDown";
import { getPortFolioListAction, getPortFolioCashAction, getPortFolioCreditFacilityAction ,getPortFolioCashAccountAction } from "../../actions/portfolioAction";
import { getTransactionStatusAction } from "../../actions/transactionAction";
import { sbaAxios } from "../../utils/sbaAxios";
import { insertUpdateTransaction, getPortfolioDetailAPI, getPortfolioNonCashAccounts } from "../../../config/apiConfig";
import { SBDatePicker } from "../../UiComponents/SBDatePicker";
import { SBNotify } from "../../utils/sbNotify";
import { ToastContainer } from "react-toastify";
import { currencyFormatter,getTransactionByID,gettransactionEditAccess } from "../utils";
import { SBACurrencyInput } from "../../UiComponents/SBACurrencyInput";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import moment from "moment";
export const Payout = () => {
    const dispatch = useDispatch();
    const Gstate = useSelector((state) => state);
    const history = useNavigate();
    const params = useParams();
    const locationData = useLocation();

    // Getting Transaction ID From Previous page if Not Assigning the value as 0;  
    const transactionId = parseInt(params?.TransId) || 0;
    const objType = parseInt(params?.ObjectType);
    const iseditable = transactionId === 0 ? false : true;
    const [transactionData, setTransactionData] = useState(plainPayoutdata);


    const statusStore = Gstate.transaction.statusList || [];
    const portfolioList = Gstate.portfolio.portfolioList || [];
    const FromAccount = Gstate.portfolio.TOCash || [];
    const [ToAccount, setToAccount] = useState([]);
    const [statusDS, setStatusDS] = useState(statusStore);
    const [portfolio, setPortfolio] = useState();
    const[transactionEditAccess,setTransactionEditAccess]=useState(false);
    const statusVal = { "TransStatus": transactionData.TradeStatusName, "TransStatusId": transactionData.TradeStatusId };
    const portfolioVal = { "PortfolioId": transactionData.PortfolioId, "PortfolioName": transactionData.PortfolioName }
    const selectedfromaccount = transactionData.ChildDetails.length > 0 ? { "AssetId": transactionData.AssetId, "AssetName": transactionData.AssetName } : ""
    const selectedtoaccount = { "AssetId": transactionData.AccountIdToBalance, "AssetName": transactionData.AccountIdToBalanceName }
    const [showModal, setShowModal] = useState(false);

    const cmtDataPT = {
        assetType: {
            CurrencyId: 0,
            CurrencyCode: ""
        },
        Asset: {},
        Portfolio: {},
        Status: {},
        amount: null,
        decription: '',
        releaseCommitment: false,
        Date: new Date(),
        ExchangeRate: null,
        LocalAmount: null,
    }


    const Level = objType == 1 ? [
        {
            BreadCrumb: "Transactions >",
            Routes: `${UrlPath.Transactions}${params.AssetId}`,
        },
        {
            BreadCrumb: "PayOut",
            Routes: `${UrlPath.Payout}${params.AssetId}`,
        },
    ] :
        [
            {
                BreadCrumb: "Transactions >",
                Routes: `/${UrlPath.portfolioTransaction}${params.EntityId}`,
            },
            {
                BreadCrumb: "PayOut",
                Routes: `/${UrlPath.PortfolioPayout}${params.EntityId}`,
            },
        ];




    useEffect(() => {

        document.title = "Transactions PayOut";
        setTransactionEditUserAccess();
        if (objType == 1) {
            setTransactionByID(transactionId);
            
            getAccountList(params?.EntityId);
           
        }
        else if (params.ObjectType == 3) {
            setTransactionByID(transactionId);
            setPortfolioByID(params?.EntityId);
            getAccountList(params?.EntityId);
            dispatch(getPortFolioCashAccountAction(params?.EntityId));
        }
        dispatch(getTransactionStatusAction());
        dispatch(getPortFolioListAction(null));
        dispatch(getPortFolioCashAction());
        dispatch(getPortFolioCreditFacilityAction());
    }, []);

    useEffect(() => {
        setStatusDS(statusStore)
        setTransactionData(value => ({ ...value, Status: statusStore[2] }));
    }, [statusStore]);

  // User Access Rights
  const setTransactionEditUserAccess= async()=>
  {
      const access = await gettransactionEditAccess();
      setTransactionEditAccess(access);
  }
    
    const getAccountList = async (id) => {
        try {
            const list = await getPortfolioLedgerAccount(id);
            setToAccount(list);
        }
        catch {
            setToAccount([]);
        }
    }


    const setPortfolioByID = async (Id) => {
        try {
            const portfolio = await getPortfolioDetailsByID(Id);
            setTransactionData(value => ({ ...value, PortfolioId: portfolio?.PortfolioId, PortfolioName: portfolio?.PortfolioName }));
            setPortfolio(portfolio);
        }
        catch (e) {
            setTransactionData(value => ({ ...value, PortfolioId: 0, PortfolioName: '' }));
            setPortfolio({});
        }

    };
    const setTransactionByID = async (id) => {
        if (id > 0) {
            try {
                const details = await getTransactionByID(id);
                setTransactionData(details);
                setPortfolioByID(details.PortfolioId);
                dispatch(getPortFolioCashAccountAction(details?.PortfolioId));
            } catch (e) {
                setTransactionData(plainPayoutdata);
            }
        }
        else {
            setTransactionData(plainPayoutdata);
        }

    };
    // Control onchange
    const portfolioDDChng = (e) => {
        if (e.value) {
            const portfolio = e.value;
            setPortfolioByID(e.value.PortfolioId);
            setTransactionData(value => ({ ...value, AssetId: 0, AssetName: '' }))
            getAccountList(e.value.PortfolioId);
            dispatch(getPortFolioCashAccountAction(e.value.PortfolioId));

            if (objType === 3) {
                history(`/${UrlPath.PortfolioPayout}0/${e.value.PortfolioId}/3`);
                setTransactionData(value => ({
                    ...value, AccountIdToBalance: 0, AccountIdToBalanceName:"", TransDate: TransactionDate, TransAmount: 0, 
                    LocalAmount: 0, ExchangeRate: 1, TransDescription:""
                }));
            }

        }
    };
    const statusDDChng = (e) => {
        if (e.value) {
            setTransactionData(value => ({ ...value, TradeStatusId: e.value.TransStatusId, TradeStatusName: e.value.TransStatus }));
        }
    };
    const udpateDate = (e) => {
        if (e) {
            setTransactionData(value => ({ ...value, TransDate: e.toISOString() }))
        }
    };
    const fromaccountChange = (e) => {
        if (e.value) {
            setTransactionData(value => ({
                ...value,
                AssetId: e.value.AssetId,
                AssetName: e.value.AssetName
            }));
        } else {
            // Handle null or undefined value
            console.error("Invalid value:", e.value);
        }
       // setTransactionData(value => ({ ...value, AssetId: e.value.AssetId, AssetName: e.value.AssetName }));

    }

    const ToaccountChange = (e) => {
        if (e.value) {
            setTransactionData(value => ({
                ...value,
                AccountIdToBalance: e.value.AssetId,
                AccountIdToBalanceName: e.value.AssetName
            }));
        } else {
            // Handle null or undefined value
            console.error("Invalid value:", e.value);
        }
      //  setTransactionData(value => ({ ...value, AccountIdToBalance: e.value.AssetId, AccountIdToBalanceName: e.value.AssetName }));

    }
    const savePayoutdata = () => {
        let saveSuccess = true;
        const savedata = {
            "transId": transactionId,
            "portfolioId": transactionData.PortfolioId,
            "assetId": transactionData.AssetId,
            "shareClassId": 0,
            "assetLotId": 0,
            "accountIdToBalance": transactionData.AccountIdToBalance,
            "tradeStatusId": transactionData.TradeStatusId,
            "transTypeId": 2,
            "transDate": transactionData.TransDate,
            "transAmount": transactionData.TransAmount,
            "localAmount": transactionData.LocalAmount,
            "exchangeRateId": 0,
            "exchangeRate": transactionData.ExchangeRate,
            "allocationDate": "",
            "shares": 0,
            "nav": 0,
            "transDescription": transactionData.TransDescription ? transactionData.TransDescription : "",
            "initialAllocationDate": "",
            "isFullRedemption": false,
            "isInsurance": false,
            "isFee": false,
            "isCommitmentRelease": false,
            "modifiedBy": 0,
            "childTrans": transactionId === 0 ? [] : transactionData.ChildDetails
        };

        if (!transactionData.TradeStatusName || transactionData.TradeStatusName === "") {
            SBNotify({ Msg: "Please Select Status ", type: "error" });
            saveSuccess = false;
        }
        else if (!transactionData.AccountIdToBalance || transactionData.AccountIdToBalance === "") {
            SBNotify({ Msg: "To Account is Required", type: "error" });
            saveSuccess = false;
        }
        else if (!transactionData.AssetId || transactionData.AssetId === 0) {
            SBNotify({ Msg: "From Account is Required", type: "error" });
            saveSuccess = false;
        }
        else if (!transactionData.PortfolioId || transactionData.PortfolioId === 0) {
            SBNotify({ Msg: "Portfolio is Required", type: "error" });
            saveSuccess = false;
        }
        else if (!transactionData.TransAmount) {

            SBNotify({ Msg: "Please Enter Amount", type: "error" });
            saveSuccess = false;
        }
        else if (transactionData.TransAmount === 0) {
            SBNotify({ Msg: "Please Enter Amount", type: "error" });
            saveSuccess = false;
        }

        else if (!transactionData.TransDate) {
            SBNotify({ Msg: "Please Choose Transaction Date", type: "error" });
            saveSuccess = false;
        }
        if (saveSuccess) {
            sbaAxios({
                url: `${insertUpdateTransaction}`,
                method: "post",
                data: savedata,
            })
                .then((response) => {
                    if (response) {
                        SBNotify({
                            type: "success",
                            Msg: " Payout Added Successfully",
                        });
                        navigateBack();
                       
                    } else {
                        SBNotify({
                            type: "error",
                            Msg: `Failed to Update`,
                        });
                    }
                })
                .catch(() => { });
        }
    }


    const navigateBack = () => {
        if (objType === 1)
            history(`${UrlPath.Transactions}${params.EntityId}`);
        if (objType === 3)
            history(`/${UrlPath.portfolioTransaction}${transactionData.PortfolioId}`);
    };
    const handleClick = () => {
        setShowModal(true);

    };

    const closeModal = () => {
        setShowModal(false);
    }

    return (
        <>
            <TopBar label={"Transactions"} />
            <div id="AddtoPorfolio" className="mainContentData">
                <BreadCrumbs Levels={Level} />
                <div className="asset-detail-screen p-3">
                    <div className="detail p-4">
                        <div className="col-lg-12 px-0">
                            <div className="row m-0">
                                <div className="row mb-4">
                                    <div className="col-md-4">
                                        <label className="mb-1 label">Status<span class="mandatory">*</span></label>
                                        <div>
                                            <SBADropDown
                                                className="w-75"
                                                data={statusDS}
                                                textField={"TransStatus"}
                                                valueField={"TransStatusId"}
                                                value={statusVal.TransStatus ? statusVal : statusDS[2]}
                                                onChange={statusDDChng}

                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <label className="mb-1 label">Portfolio<span class="mandatory">*</span></label>
                                        <div>
                                            <SBAComboBox
                                                className="w-75"
                                                data={portfolioList}
                                                textField={"PortfolioName"}
                                                valueField={"PortfolioId"}
                                                onChange={portfolioDDChng}
                                                value={portfolioVal}
                                                disabled={iseditable}
                                            />
                                        </div>
                                    </div>
                                   
                                 
                                </div>
                                <div className="row mb-4">

                                    <div className="col-md-4">
                                        <label className="mb-1 label">From Account<span class="mandatory">*</span></label>
                                        <div>
                                            <SBAComboBox
                                                className="w-75"
                                                data={FromAccount}
                                                textField={"AssetName"}
                                                valueField={"AssetId"}
                                                onChange={fromaccountChange}
                                                value={selectedfromaccount}

                                            />
                                        </div>
                                    </div>
                               
                                    <div className="col-md-4">
                                        <label className="mb-1 label">To Account<span class="mandatory">*</span></label>
                                        <div>
                                            <SBAComboBox
                                                className="w-75"
                                                data={ToAccount}
                                                textField={"AssetName"}
                                                valueField={"AssetId"}
                                                value={selectedtoaccount}
                                                onChange={ToaccountChange}
                                            />
                                        </div>
                                    </div>
                                   
                                                                
                                </div>


                                <div className="row mb-4">

                                    <div className="col-md-4">
                                        <div> <label className="mb-1 mt-2 label"></label></div>
                                        <label className="mb-1 label">Transaction Date</label>
                                        <span class="mandatory">*</span>
                                        <div className="d-flex gap-2">
                                            <SBDatePicker className="w-75" value={transactionData.TransDate ? moment(transactionData.TransDate) : null} onChange={udpateDate} />
                                        </div>
                                    </div>
                               

                                    <div className="col-md-4">

                                        <div> <Link className="noUnderLine" onClick={handleClick}>USD</Link></div>
                                    <label className="mb-1 label"> Amount<span class="mandatory">*</span></label>
                                    <div className="d-flex gap-2">
                                        <SBACurrencyInput
                                            className={"form-control w-75"}

                                            decimalsLimit={2}
                                            value={transactionData?.TransAmount ? (transactionData?.TransAmount)?.toFixed(2) : '0.00'}
                                            onBlur={(e) => {
                                                const parsedValue = parseFloat(e);
                                                setTransactionData(value => ({
                                                    ...value,
                                                    TransAmount: parsedValue,
                                                    LocalAmount: parsedValue * transactionData?.ExchangeRate
                                                }));
                                            }}
                                        />

                                       
                                    </div>
                                </div>


                                    <div className="col-md-4">
                                        <div> <Link className="noUnderLine" onClick={handleClick}>{portfolio?.CurrencyCode}</Link><span style={{marginLeft:'8px'}}>({currencyFormatter(transactionData.ExchangeRate, 2)})</span></div>
                                    <label className="mb-1 label"> Local Amount</label>
                                    <div className="d-flex gap-2">
                                        <input
                                            className="form-control w-75"
                                            disabled={true}
                                            type="number"
                                            value={transactionData?.LocalAmount && typeof transactionData.LocalAmount === 'number' ? transactionData.LocalAmount.toFixed(2) : '0.00'}
                                        />
                                    </div>
                                </div>
                             </div>
                            </div>
                            <div className="row m-0">
                                
                                <div className="col-md-6">
                                    <label className="mb-1 label">Description</label>
                                    <div style={{ height: 100, width: "245%" }}>
                                        <textarea className="form-control w-75" type="text" value={transactionData?.TransDescription} onChange={(e) => { setTransactionData(value => ({ ...value, TransDescription: e.target.value })) }} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            className="m-3 d-flex justify-content-end"
                            style={{ paddingBottom: "15px", paddingRight: "130px" }}
                        >
                            <button className="s-sm-btn" onClick={() => { navigateBack() }}>
                                Cancel
                            </button>
                            {transactionId !== 0 ? (
                                <button className="ms-2 p-sm-btn" disabled={!transactionEditAccess || transactionData.IsLocked} onClick={savePayoutdata}>
                                    Save
                                </button>
                            ): (
                                    <button className="ms-2 p-sm-btn" disabled={false} onClick={savePayoutdata}>
                                        Save
                                    </button>
                                )}

                                

                        </div>

                    </div>
                </div>
                
                {<Modal show={showModal}>
                    <Modal.Header closeButton onClick={closeModal}>
                        <Modal.Title>Exchange Rate</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="mb-4">
                            <label className="mb-1 label"> Exchange Rate</label>
                            <div className="d-flex gap-2">
                                <SBACurrencyInput
                                    className={"form-control w-75"}

                                    decimalsLimit={2}
                                    value={transactionData?.ExchangeRate ? transactionData?.ExchangeRate : null}
                                    onBlur={(e) => {
                                        const parsedValue = parseFloat(e);
                                        setTransactionData(value => ({
                                            ...value,
                                            ExchangeRate: parsedValue,
                                            LocalAmount: transactionData?.TransAmount * parsedValue
                                        }));
                                    }}
                                    disableGroupSeparators={true}
                                />


                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="s-sm-btn mx-1" onClick={closeModal} > Cancel</button>
                        <button className='p-sm-btn mx-1' onClick={closeModal} >
                            Ok
          </button>
                    </Modal.Footer>
                </Modal>}
            </div>
            <ToastContainer></ToastContainer>
        </>
    );


}
// To Account Data

const getPortfolioLedgerAccount = async (id) => {
    try {
        const response = await sbaAxios({ url: getPortfolioNonCashAccounts + '/' + id });
        return response;
    }
    catch (e) {
        return [];
    }
}
const getPortfolioDetailsByID = async (portfolioId) => {
    try {
        const response = await sbaAxios({ url: getPortfolioDetailAPI + portfolioId });
        return response;
    }
    catch (e) {
        console.log(e, 'Error Fetching the portfolio details')
        return {};
    };
};
var date = new Date();
var TransactionDate = new Date(date.getFullYear(), date.getMonth()+1, 1);
const plainPayoutdata = {
    "TransId": 0,
    "TransTypeId": 9,
    "TransTypeName": "Payout",
    "PortfolioId": 0,
    "PortfolioName": "",
    "AssetId": 0,
    "AssetName": "",
    "AccountIdToBalanceName": "",
    "AccountIdToBalance": 0,
    "ShareclassId": 0,
    "ShareClassName": "",
    "AssetLotId": 0,
    "AssetLotName": "",
    "TradeStatusId": 2,
    "TradeStatusName": "Executed",
    "TransDate": TransactionDate,
    "TransAmount": 0,
    "LocalAmount": "0.00",
    "CurrencyId": 0,
    "CurrencyCode": "",
    "ExchangeRateId": 0,
    "ExchangeRate": 1,
    "IsFullRedemption": false,
    "IsInsurance": false,
    "IsFee": false,
    "IsCommitmentRelease": false,
    "TransDescription": "",
    "ModifiedById": 0,
    "ModifiedByName": "",
    "ChildDetails": [{
        "AssetId": 0,
        "AssetLotId": 0,
        "AssetLotName": "",
        "AssetName": "",
        "AssetId": 0,
        "InitialAllocationDate": "",
        "ModifiedById": 0,
        "ModifiedByName": "",
        "ShareClassName": "",
        "ShareclassId": 0,  
        "TotalNrOfShares": 0,
        "TotalPosition": 0,
        "TransAmount": "0.00",
        "TransDate": TransactionDate,        
        "TransDescription": "",
        "TransId": 0,
        "TransPercentage": 0,
        "TransTypeId": 2,
        "TransTypeName": "Payout"
        
    }
    ]
}